export const POOR_RESOLUTION_MESSAGE =
  'Poor resolution: Image may print blurry or pixelated, we suggest a smaller sized print';

export const ADVANCED_EDITOR_WARNING_MESSAGE =
  'Poor resolution: Image may print blurry or pixelated';

export const SMALL_CROP_MESSAGE =
  'Cropped too small: This crop may print blurry or pixelated, we suggest a larger crop or a different print size';
